import React from 'react';
import { Form, Input } from 'antd';

const { TextArea } = Input;

/**
 * Reusable TextArea Field Component
 * For multi-line text inputs
 * 
 * @param {string} name - Field name
 * @param {string} label - Field label
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Whether field is required
 * @param {boolean} readOnly - Whether field is read-only
 * @param {number} rows - Number of rows
 * @param {number} maxLength - Maximum character length
 * @param {boolean} showCount - Show character count
 * @param {Array} rules - Additional validation rules
 * @param {object} ...props - Additional props passed to TextArea
 */
const TextAreaField = ({ 
  name, 
  label, 
  placeholder, 
  required = false, 
  readOnly = false,
  rows = 4,
  maxLength,
  showCount = false,
  rules = [],
  ...props 
}) => (
  <Form.Item
    name={name}
    label={label}
    rules={required ? [{ required: true, message: `Please enter ${label.toLowerCase()}` }, ...rules] : rules}
  >
    <TextArea 
      placeholder={placeholder}
      size="large"
      rows={rows}
      maxLength={maxLength}
      showCount={showCount}
      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
      readOnly={readOnly}
      style={readOnly ? { cursor: 'not-allowed', backgroundColor: '#f9fafb' } : { backgroundColor: '#f9fafb' }}
      {...props}
    />
  </Form.Item>
);

export default TextAreaField;
